module.exports = __webpack_public_path__ + "media/logos/press-logo-in-house-ec84138c.png";